import { DealersAndLocationsDropdownKeys } from "components/DealersAndLocationsDropdown/queryKeys";
import { typedQueryClient, useTypedQuery } from "hooks";

export const useAllLocationsSelectedDealerId = () => {
  const allLocationsSelectedDealerId = useTypedQuery({ queryKey: DealersAndLocationsDropdownKeys.allLocationsSelectedDealerId, initialData: 0 }).data;
  return { allLocationsSelectedDealerId };
};

export const setAllLocationsSelectedDealerId = (allLocationsSelectedDealerId: number) =>
  typedQueryClient.setQueryData(DealersAndLocationsDropdownKeys.allLocationsSelectedDealerId, allLocationsSelectedDealerId);
